module.exports = __webpack_public_path__ + "img/worrying.b0a3f05b.png";